"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeRampLodestarDefinitions = exports.fontSizeDefinitions = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _typographyConstants = require("./typographyConstants");
/**
 * Font Sizing
 * (includes line height)
 */
const fontSizeDefinitions = {
  "13": {
    fontSize: "13px",
    lineHeight: "18px"
  },
  "14": {
    fontSize: "14px",
    lineHeight: "18px"
  },
  "15": {
    fontSize: "15px",
    lineHeight: "18px"
  },
  "18": {
    fontSize: "18px",
    lineHeight: "24px"
  },
  "24": {
    fontSize: "24px",
    lineHeight: "28px"
  },
  "32": {
    fontSize: "32px",
    lineHeight: "34px"
  },
  "40": {
    fontSize: "40px",
    lineHeight: "48px"
  }
};

/**
 * Type ramp style definitions
 */
exports.fontSizeDefinitions = fontSizeDefinitions;
const typeRampLodestarDefinitions = {
  headlineXLarge: {
    fontWeight: _typographyConstants.fontWeight.bold,
    fontFamily: "TT Norms Pro",
    color: (0, _designTokensReact.color)("color--text--neutral--strong"),
    ...fontSizeDefinitions["40"]
  },
  headlineLarge: {
    fontWeight: _typographyConstants.fontWeight.bold,
    fontFamily: "TT Norms Pro",
    color: (0, _designTokensReact.color)("color--text--neutral--strong"),
    ...fontSizeDefinitions["32"]
  },
  headlineMedium: {
    fontWeight: _typographyConstants.fontWeight.bold,
    fontFamily: "TT Norms Pro",
    color: (0, _designTokensReact.color)("color--text--neutral--strong"),
    ...fontSizeDefinitions["24"]
  },
  headlineSmall: {
    fontWeight: _typographyConstants.fontWeight.bold,
    fontFamily: "TT Norms Pro",
    color: (0, _designTokensReact.color)("color--text--neutral--strong"),
    ...fontSizeDefinitions["18"]
  },
  headerLarge: {
    fontWeight: _typographyConstants.fontWeight.semiBold,
    fontFamily: "default",
    color: (0, _designTokensReact.color)("color--text--neutral--default"),
    ...fontSizeDefinitions["15"]
  },
  headerSmall: {
    fontWeight: _typographyConstants.fontWeight.semiBold,
    fontFamily: "default",
    color: (0, _designTokensReact.color)("color--text--neutral--default"),
    ...fontSizeDefinitions["13"]
  },
  buttonLarge: {
    fontWeight: _typographyConstants.fontWeight.bold,
    fontFamily: "default",
    color: (0, _designTokensReact.color)("color--text--neutral--default"),
    ...fontSizeDefinitions["14"]
  },
  buttonMedium: {
    fontWeight: _typographyConstants.fontWeight.semiBold,
    fontFamily: "default",
    color: (0, _designTokensReact.color)("color--text--neutral--default"),
    ...fontSizeDefinitions["13"]
  },
  titlesEmphasis: {
    fontWeight: _typographyConstants.fontWeight.semiBold,
    fontFamily: "default",
    color: (0, _designTokensReact.color)("color--text--neutral--default"),
    ...fontSizeDefinitions["13"]
  },
  bodyStrong: {
    fontWeight: _typographyConstants.fontWeight.medium,
    fontFamily: "default",
    color: (0, _designTokensReact.color)("color--text--neutral--default"),
    ...fontSizeDefinitions["13"]
  },
  bodyText: {
    fontWeight: _typographyConstants.fontWeight.regular,
    fontFamily: "default",
    color: (0, _designTokensReact.color)("color--text--neutral--default"),
    ...fontSizeDefinitions["13"]
  },
  metadata: {
    fontWeight: _typographyConstants.fontWeight.regular,
    fontFamily: "default",
    color: (0, _designTokensReact.color)("color--text--neutral--weak"),
    ...fontSizeDefinitions["13"]
  }
};
exports.typeRampLodestarDefinitions = typeRampLodestarDefinitions;
//# sourceMappingURL=lodestarConstants.js.map